import { useSearchParams } from "react-router";
import { useUiLang } from "@/lib/lang";

// The sign-in page: one button, "Sign in with Google", in English or Arabic. The hub's Worker checks the Google account
// against the hub's users (worker/api.ts); the reasons for coming back here are shown in plain words.

const ERRORS: Record<string, [string, string]> = {
  "not-allowed": ["This Google account isn't a hub user. Ask an owner to add it, then sign in again.", "حساب جوجل ده مش مضاف في اللوحة. اطلب من المالك يضيفه، وبعدين ادخل تاني."],
  failed: ["Signing in didn't finish. Please try again.", "الدخول ما كملش. جرّب تاني."],
  setup: ["Sign-in isn't set up on this hub yet. Ask the developer.", "الدخول لسه مش متظبط في اللوحة دي. اسأل المطوّر."],
};

export function Login() {
  const { L, lang, dir, setLang } = useUiLang();
  const [params] = useSearchParams();
  const error = ERRORS[params.get("error") ?? ""];
  const next = params.get("next") ?? "/";
  return (
    <main className="grid min-h-svh place-items-center bg-midnight p-4 text-offwhite" dir={dir} lang={lang}>
      <div className="w-full max-w-sm rounded-3xl bg-night p-6 sm:p-8">
        <div className="flex items-center justify-between gap-3">
          <p className="font-mono text-[0.7rem] tracking-[0.25em] text-offwhite/70 uppercase">{L("Dashboards", "لوحات التحكم")}</p>
          <button type="button" onClick={() => setLang(lang === "ar" ? "en" : "ar")} lang={lang === "ar" ? "en" : "ar"} className="min-h-11 rounded-lg px-3 text-sm font-bold text-amber hover:bg-offwhite/10">
            {lang === "ar" ? "English" : "العربية"}
          </button>
        </div>
        <h1 className="mt-2 text-3xl font-bold tracking-tight">{L("Sign in", "تسجيل الدخول")}</h1>
        <p className="mt-2 text-offwhite/80">{L("With the Google account your team owner added to the hub.", "بحساب جوجل اللي المالك ضافه في اللوحة.")}</p>
        {error && (
          <p role="alert" className="mt-5 rounded-xl border border-amber/50 bg-amber/10 p-3 text-sm">
            {L(...error)}
          </p>
        )}
        <a
          href={`/api/auth/google?next=${encodeURIComponent(next)}`}
          className="mt-6 flex min-h-12 items-center justify-center gap-3 rounded-xl bg-offwhite px-5 font-bold text-midnight transition-colors hover:bg-amber"
        >
          <svg viewBox="0 0 24 24" className="size-5" aria-hidden>
            <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5a5.6 5.6 0 0 1-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8z" />
            <path fill="#34A853" d="M12 24c3.2 0 6-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.7-4.9H1.3v3.1A12 12 0 0 0 12 24z" />
            <path fill="#FBBC05" d="M5.3 14.4a7.2 7.2 0 0 1 0-4.7V6.6H1.3a12 12 0 0 0 0 10.9l4-3.1z" />
            <path fill="#EA4335" d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.5-3.5A12 12 0 0 0 1.3 6.6l4 3.1C6.3 6.9 8.9 4.8 12 4.8z" />
          </svg>
          {L("Sign in with Google", "الدخول بحساب جوجل")}
        </a>
      </div>
    </main>
  );
}
